// // // import React from "react";
// // // import {
// // //   CalendarClock,
// // //   Sofa,
// // //   FlaskConical,
// // //   RefreshCcw,
// // //   Truck,
// // //   HelpCircle,
// // //   Scissors,
// // //   MessageSquare,
// // //   Timer,
// // //   Info,
// // //   ShieldCheck,
// // //   UserCheck,
// // //   PhoneCall,
// // //   PackageCheck,
// // //   Brush,
// // //   Smile,
// // // } from "lucide-react";

// // // const questions = [
// // //   { icon: <CalendarClock size={16} />, text: "Halılar kaç günde teslim ediliyor?" },
// // //   { icon: <Sofa size={16} />, text: "Koltuk yıkama yerinde mi yapılıyor?" },
// // //   { icon: <FlaskConical size={16} />, text: "Kullandığınız deterjanlar sağlığa zararlı mı?" },
// // //   { icon: <RefreshCcw size={16} />, text: "Yorgan, battaniye de yıkıyor musunuz?" },
// // //   { icon: <Truck size={16} />, text: "Servis ücreti alınıyor mu?" },
// // //   { icon: <HelpCircle size={16} />, text: "Hangi tür halılar yıkanır?" },
// // //   { icon: <Scissors size={16} />, text: "Halı tamiri/overlok yapıyor musunuz?" },
// // //   { icon: <Timer size={16} />, text: "Koltuklar ne kadar sürede kurur?" },
// // //   { icon: <MessageSquare size={16} />, text: "Halılar nasıl yıkanıyor?" },
// // //   { icon: <Info size={16} />, text: "Perde yıkama yapıyor musunuz?" },
// // //   { icon: <ShieldCheck size={16} />, text: "Antibakteriyel ürün mü kullanılıyor?" },
// // //   { icon: <UserCheck size={16} />, text: "Personeliniz yerinde hizmet veriyor mu?" },
// // //   { icon: <PhoneCall size={16} />, text: "İletişim saatleriniz nedir?" },
// // //   { icon: <PackageCheck size={16} />, text: "Paketleme nasıl yapılıyor?" },
// // //   { icon: <Brush size={16} />, text: "El dokuma halılar zarar görür mü?" },
// // //   { icon: <Smile size={16} />, text: "Memnun kalmazsam ne olur?" },
// // // ];

// // // const FAQBox = () => {
// // //   return (
// // //     <div className="bg-black border border-gray-200 rounded-xl shadow p-4 w-80">
// // //       <h3 className="text-lg font-semibold text-[#00704A] mb-4">
// // //         Sıkça Sorulan Sorular
// // //       </h3>
// // //       <ul className="text-sm space-y-3 text-white">
// // //         {questions.map((item, i) => (
// // //           <li
// // //             key={i}
// // //             className="flex items-center gap-2 hover:text-green-700 cursor-pointer transition"
// // //           >
// // //             {item.icon}
// // //             <span>{item.text}</span>
// // //           </li>
// // //         ))}
// // //       </ul>
// // //     </div>
// // //   );
// // // };

// // // export default FAQBox;
// // import React, { useState } from "react";
// // import {
// //   CalendarClock,
// //   Sofa,
// //   FlaskConical,
// //   RefreshCcw,
// //   Truck,
// //   HelpCircle,
// //   Scissors,
// //   MessageSquare,
// //   Timer,
// //   Info,
// //   ShieldCheck,
// //   UserCheck,
// //   PhoneCall,
// //   PackageCheck,
// //   Brush,
// //   Smile,
// //   ChevronDown,
// //   ChevronUp,
// // } from "lucide-react";

// // const questions = [
// //   {
// //     icon: <CalendarClock size={16} />,
// //     text: "Halılar kaç günde teslim ediliyor?",
// //     answer: "Genellikle 2-3 iş günü içinde teslim edilir.",
// //   },
// //   {
// //     icon: <Sofa size={16} />,
// //     text: "Koltuk yıkama yerinde mi yapılıyor?",
// //     answer: "Evet, koltuk yıkama işlemi yerinde yapılmaktadır.",
// //   },
// //   {
// //     icon: <FlaskConical size={16} />,
// //     text: "Kullandığınız deterjanlar sağlığa zararlı mı?",
// //     answer: "Hayır, tamamen organik ve alerjen içermeyen ürünler kullanıyoruz.",
// //   },
// //   {
// //     icon: <RefreshCcw size={16} />,
// //     text: "Yorgan, battaniye de yıkıyor musunuz?",
// //     answer: "Evet, yorgan ve battaniye temizliği de yapıyoruz.",
// //   },
// //   {
// //     icon: <Truck size={16} />,
// //     text: "Servis ücreti alınıyor mu?",
// //     answer: "Hayır, servisimiz ücretsizdir.",
// //   },
// //   {
// //     icon: <HelpCircle size={16} />,
// //     text: "Hangi tür halılar yıkanır?",
// //     answer: "Tüm makine halıları, shaggy, yün ve el dokuma halılar yıkanır.",
// //   },
// //   {
// //     icon: <Scissors size={16} />,
// //     text: "Halı tamiri/overlok yapıyor musunuz?",
// //     answer: "Evet, isteğe bağlı olarak halı tamiri ve overlok hizmetimiz vardır.",
// //   },
// //   {
// //     icon: <Timer size={16} />,
// //     text: "Koltuklar ne kadar sürede kurur?",
// //     answer: "Genellikle 4-6 saat içinde kurur.",
// //   },
// //   {
// //     icon: <MessageSquare size={16} />,
// //     text: "Halılar nasıl yıkanıyor?",
// //     answer: "Tam otomatik makinelerde, hijyenik şartlarda yıkanır.",
// //   },
// //   {
// //     icon: <Info size={16} />,
// //     text: "Perde yıkama yapıyor musunuz?",
// //     answer: "Evet, stor ve zebra perde yıkama hizmetimiz mevcuttur.",
// //   },
// //   {
// //     icon: <ShieldCheck size={16} />,
// //     text: "Antibakteriyel ürün mü kullanılıyor?",
// //     answer: "Evet, her işlem antibakteriyel içeriklerle desteklenir.",
// //   },
// //   {
// //     icon: <UserCheck size={16} />,
// //     text: "Personeliniz yerinde hizmet veriyor mu?",
// //     answer: "Evet, koltuk ve yatak temizliği yerinde yapılır.",
// //   },
// //   {
// //     icon: <PhoneCall size={16} />,
// //     text: "İletişim saatleriniz nedir?",
// //     answer: "08:00 – 22:00 saatleri arasında hizmet veriyoruz.",
// //   },
// //   {
// //     icon: <PackageCheck size={16} />,
// //     text: "Paketleme nasıl yapılıyor?",
// //     answer: "Halılar steril poşetlerle özenle paketlenir.",
// //   },
// //   {
// //     icon: <Brush size={16} />,
// //     text: "El dokuma halılar zarar görür mü?",
// //     answer: "Hayır, özel tekniklerle zarar vermeden yıkanır.",
// //   },
// //   {
// //     icon: <Smile size={16} />,
// //     text: "Memnun kalmazsam ne olur?",
// //     answer: "Koşulsuz memnuniyet garantisi sunuyoruz.",
// //   },
// // ];

// // const FAQBox = () => {
// //   const [openIndex, setOpenIndex] = useState(null);

// //   const toggleAnswer = (index) => {
// //     setOpenIndex(openIndex === index ? null : index);
// //   };

// //   return (
// //     <div className="bg-black border border-gray-200 rounded-xl shadow p-4 w-full max-w-md">
// //       <h3 className="text-lg font-semibold text-[#00704A] mb-4">
// //         Sıkça Sorulan Sorular
// //       </h3>
// //       <ul className="text-sm space-y-3 text-white mb-1">
// //         {questions.map((item, index) => (
// //           <li key={index}>
// //             <button
// //               onClick={() => toggleAnswer(index)}
// //               className="flex items-center justify-between w-full hover:text-green-500 transition"
// //             >
// //               <div className="flex items-center gap-2">
// //                 {item.icon}
// //                 <span>{item.text}</span>
// //               </div>
// //               {openIndex === index ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
// //             </button>
// //             {openIndex === index && (
// //               <p className="mt-2 text-gray-300 text-xs pl-6">{item.answer}</p>
// //             )}
// //           </li>
// //         ))}
// //       </ul>
// //     </div>
// //   );
// // };

// // export default FAQBox;
// import React, { useState } from "react";
// import {
//   CalendarClock,
//   Sofa,
//   FlaskConical,
//   RefreshCcw,
//   Truck,
//   HelpCircle,
//   Scissors,
//   MessageSquare,
//   Timer,
//   Info,
//   ShieldCheck,
//   UserCheck,
//   PhoneCall,
//   PackageCheck,
//   Brush,
//   Smile,
//   ChevronDown,
//   ChevronUp,
// } from "lucide-react";

// const questions = [
//   {
//     icon: <CalendarClock size={18} />,
//     text: "Halılar kaç günde teslim ediliyor?",
//     answer: "Genellikle 2-3 iş günü içinde teslim edilir.",
//   },
//   {
//     icon: <Sofa size={18} />,
//     text: "Koltuk yıkama yerinde mi yapılıyor?",
//     answer: "Evet, koltuk yıkama işlemi yerinde yapılmaktadır.",
//   },
//   {
//     icon: <FlaskConical size={18} />,
//     text: "Kullandığınız deterjanlar sağlığa zararlı mı?",
//     answer: "Hayır, tamamen organik ve alerjen içermeyen ürünler kullanıyoruz.",
//   },
//   {
//     icon: <RefreshCcw size={18} />,
//     text: "Yorgan, battaniye de yıkıyor musunuz?",
//     answer: "Evet, yorgan ve battaniye temizliği de yapıyoruz.",
//   },
//   {
//     icon: <Truck size={18} />,
//     text: "Servis ücreti alınıyor mu?",
//     answer: "Hayır, servisimiz ücretsizdir.",
//   },
//   {
//     icon: <HelpCircle size={18} />,
//     text: "Hangi tür halılar yıkanır?",
//     answer: "Tüm makine halıları, shaggy, yün ve el dokuma halılar yıkanır.",
//   },
//   {
//     icon: <Scissors size={18} />,
//     text: "Halı tamiri/overlok yapıyor musunuz?",
//     answer: "Evet, isteğe bağlı olarak halı tamiri ve overlok hizmetimiz vardır.",
//   },
//   {
//     icon: <Timer size={18} />,
//     text: "Koltuklar ne kadar sürede kurur?",
//     answer: "Genellikle 4-6 saat içinde kurur.",
//   },
//   {
//     icon: <MessageSquare size={18} />,
//     text: "Halılar nasıl yıkanıyor?",
//     answer: "Tam otomatik makinelerde, hijyenik şartlarda yıkanır.",
//   },
//   {
//     icon: <Info size={18} />,
//     text: "Perde yıkama yapıyor musunuz?",
//     answer: "Evet, stor ve zebra perde yıkama hizmetimiz mevcuttur.",
//   },
//   {
//     icon: <ShieldCheck size={18} />,
//     text: "Antibakteriyel ürün mü kullanılıyor?",
//     answer: "Evet, her işlem antibakteriyel içeriklerle desteklenir.",
//   },
//   {
//     icon: <UserCheck size={18} />,
//     text: "Personeliniz yerinde hizmet veriyor mu?",
//     answer: "Evet, koltuk ve yatak temizliği yerinde yapılır.",
//   },
//   {
//     icon: <PhoneCall size={18} />,
//     text: "İletişim saatleriniz nedir?",
//     answer: "08:00 – 22:00 saatleri arasında hizmet veriyoruz.",
//   },
//   {
//     icon: <PackageCheck size={18} />,
//     text: "Paketleme nasıl yapılıyor?",
//     answer: "Halılar steril poşetlerle özenle paketlenir.",
//   },
//   {
//     icon: <Brush size={18} />,
//     text: "El dokuma halılar zarar görür mü?",
//     answer: "Hayır, özel tekniklerle zarar vermeden yıkanır.",
//   },
//   {
//     icon: <Smile size={18} />,
//     text: "Memnun kalmazsam ne olur?",
//     answer: "Koşulsuz memnuniyet garantisi sunuyoruz.",
//   },
// ];

// const FAQBox = () => {
//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleAnswer = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   return (
//     <section className="text-gray-800 space-y-6 leading-relaxed text-base">
//       <div className="space-y-4">
//         <h3 className="text-lg font-semibold text-[#00704A]">Sıkça Sorulan Sorular</h3>
//         <ul className="space-y-4">
//           {questions.map((item, index) => (
//             <li key={index} className="border-b pb-3">
//               <button
//                 onClick={() => toggleAnswer(index)}
//                 className="flex items-center justify-between w-full text-left hover:text-green-600 transition"
//               >
//                 <div className="flex items-center gap-3">
//                   {item.icon}
//                   <span className="font-medium">{item.text}</span>
//                 </div>
//                 {openIndex === index ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
//               </button>
//               {openIndex === index && (
//                 <p className="mt-2 text-justify text-sm text-gray-700 pl-6">{item.answer}</p>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </section>
//   );
// };

// export default FAQBox;
import React, { useState } from "react";
import {
  CalendarClock,
  Sofa,
  FlaskConical,
  RefreshCcw,
  Truck,
  HelpCircle,
  Scissors,
  MessageSquare,
  Timer,
  Info,
  ShieldCheck,
  UserCheck,
  PhoneCall,
  PackageCheck,
  Brush,
  Smile,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

const questions = [
  {
    icon: <CalendarClock size={16} />,
    text: "Halılar kaç günde teslim ediliyor?",
    answer: "Genellikle 2-3 iş günü içinde teslim edilir.",
  },
  {
    icon: <Sofa size={16} />,
    text: "Koltuk yıkama yerinde mi yapılıyor?",
    answer: "Evet, koltuk yıkama işlemi yerinde yapılmaktadır.",
  },
  {
    icon: <FlaskConical size={16} />,
    text: "Kullandığınız deterjanlar sağlığa zararlı mı?",
    answer: "Hayır, tamamen organik ve alerjen içermeyen ürünler kullanıyoruz.",
  },
  {
    icon: <RefreshCcw size={16} />,
    text: "Yorgan, battaniye de yıkıyor musunuz?",
    answer: "Evet, yorgan ve battaniye temizliği de yapıyoruz.",
  },
  {
    icon: <Truck size={16} />,
    text: "Servis ücreti alınıyor mu?",
    answer: "Hayır, servisimiz ücretsizdir.",
  },
  {
    icon: <HelpCircle size={16} />,
    text: "Hangi tür halılar yıkanır?",
    answer: "Tüm makine halıları, shaggy, yün ve el dokuma halılar yıkanır.",
  },
  {
    icon: <Scissors size={16} />,
    text: "Halı tamiri/overlok yapıyor musunuz?",
    answer: "Evet, isteğe bağlı olarak halı tamiri ve overlok hizmetimiz vardır.",
  },
  {
    icon: <Timer size={16} />,
    text: "Koltuklar ne kadar sürede kurur?",
    answer: "Genellikle 4-6 saat içinde kurur.",
  },
  {
    icon: <MessageSquare size={16} />,
    text: "Halılar nasıl yıkanıyor?",
    answer: "Tam otomatik makinelerde, hijyenik şartlarda yıkanır.",
  },
  {
    icon: <Info size={16} />,
    text: "Perde yıkama yapıyor musunuz?",
    answer: "Evet, stor ve zebra perde yıkama hizmetimiz mevcuttur.",
  },
  {
    icon: <ShieldCheck size={16} />,
    text: "Antibakteriyel ürün mü kullanılıyor?",
    answer: "Evet, her işlem antibakteriyel içeriklerle desteklenir.",
  },
  {
    icon: <UserCheck size={16} />,
    text: "Personeliniz yerinde hizmet veriyor mu?",
    answer: "Evet, koltuk ve yatak temizliği yerinde yapılır.",
  },
  {
    icon: <PhoneCall size={16} />,
    text: "İletişim saatleriniz nedir?",
    answer: "08:00 – 22:00 saatleri arasında hizmet veriyoruz.",
  },
  {
    icon: <PackageCheck size={16} />,
    text: "Paketleme nasıl yapılıyor?",
    answer: "Halılar steril poşetlerle özenle paketlenir.",
  },
  {
    icon: <Brush size={16} />,
    text: "El dokuma halılar zarar görür mü?",
    answer: "Hayır, özel tekniklerle zarar vermeden yıkanır.",
  },
  {
    icon: <Smile size={16} />,
    text: "Memnun kalmazsam ne olur?",
    answer: "Koşulsuz memnuniyet garantisi sunuyoruz.",
  },
];

const FAQBox = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="space-y-10 text-gray-800 text-base leading-loose text-justify">
      <div className="space-y-3 border-b pb-4">
        <h3 className="font-semibold text-lg text-[#00704A]">Sıkça Sorulan Sorular</h3>
        <ul className="list-none space-y-4">
          {questions.map((item, index) => (
            <li key={index} className="border-b pb-4">
              <button
                onClick={() => toggleAnswer(index)}
                className="flex items-center justify-between w-full text-left hover:text-green-600 transition"
              >
                <div className="flex items-center gap-2">
                  {item.icon}
                  <span className="font-medium">{item.text}</span>
                </div>
                {openIndex === index ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>
              {openIndex === index && (
                <p className="mt-2 text-sm text-gray-700">{item.answer}</p>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQBox;
